import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Button, Flex, Text, useDisclosure } from '@bonusly/design-system';

import { Announcement } from '../types/announcements';
import { formatDisplayDate } from '../utils/date';
import { EditAnnouncementModal } from './edit-announcement-modal';

export interface EditAnnouncementButtonProps {
	announcement: Announcement;
	type: 'posted' | 'scheduled';
}

export const EditAnnouncementButton: FC<EditAnnouncementButtonProps> = ({ announcement, type }) => {
	const { t } = useTranslation('announcements');
	const { track } = useAnalytics();
	const editModal = useDisclosure();

	const formattedDate = formatDisplayDate(announcement.start_date);

	const handleAnnouncementClick = () => {
		track(AnalyticsEvent.Announcements.EditAnnouncementButtonClicked);
		editModal.onOpen();
	};

	return (
		<>
			<Button
				colorScheme="secondary"
				data-testid="edit-announcement-button"
				height="max-content"
				mt={2}
				onClick={handleAnnouncementClick}
				px={4}
				py={2}
				variant="alpha"
				w="100%"
			>
				<Flex w="100%" flexDirection="column" alignItems="flex-start">
					<Text color="text.softest" fontSize={50} fontWeight="normal" lineHeight={5} mb={1}>
						{type === 'posted' ? t('modal.posted_date', { date: formattedDate }) : t('modal.scheduled_date', { date: formattedDate })}
					</Text>
					<Text color="text.default" fontSize={150} fontWeight="medium" lineHeight={7}>
						{announcement.title}
					</Text>
				</Flex>
			</Button>
			<EditAnnouncementModal announcement={announcement} isOpen={editModal.isOpen} onClose={editModal.onClose} />
		</>
	);
};
